import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportConversationsGet } from '@/entities/support-chat/modules/api/supportChat';
import type { ApiSupportConversationsListParams } from '@/shared/types/api/support-chat';

// Pure WebSocket-driven: the initial mount fetches once, then
// `useAdminInboxSocket` invalidates this query on every `chat.inbox` event.
// No polling, no focus/reconnect refetch — the socket is the only update path.
export const useSupportConversations = (params: ApiSupportConversationsListParams) =>
  useQuery({
    queryKey: queryKeys.supportChat.conversations(params),
    queryFn: () => apiSupportConversationsGet(params),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
